import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Applies a referral code for the signed-in caller. Runs server-side only. */
export const applyReferralCode = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((input: { code: string }) => {
    const code = String(input?.code ?? "").trim();
    if (!/^[A-Za-z0-9_-]{3,32}$/.test(code)) throw new Error("Invalid referral code.");
    return { code };
  })
  .handler(async ({ data, context }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: applied, error } = await supabaseAdmin.rpc("apply_referral_for", {
      _user_id: context.userId,
      _code: data.code,
    });
    if (error) throw new Error("Referral could not be applied.");
    return { applied: Boolean(applied) };
  });
